import React from "react"
import RevolvingText from "../revolving-text/revolving-text.component"
import dataLayerHelper from "../../helpers/datalayer.helper"
import ButtonLink from "../btn-collections/btn-collections.component"
import {
  FounderImage,
  FounderMessageTitle,
  FounderMessage,
  FromTheFounderContainer,
  FromTheFounderGrid,
  FTFLeftColumn,
  FTFRightColumn,
  FounderStraplineContainer,
} from "./from-the-founder.styles"

const FromTheFounder = ({ founderData, straplineData }) => {
  const { title, straplines, button_text, button_url } = straplineData

  return (
    <FromTheFounderContainer className="full-bleed" position="relative">
      <FromTheFounderGrid>
        <FTFLeftColumn>
          <FounderImage
            src={`${founderData.image.file.url}?w=500&fm=webp`}
            alt={"Andrei Neagoie"}
            loading="lazy"
          />
          <ButtonLink
            ghostSecondary
            internal
            url={founderData.bioBtnLink}
            onClick={() =>
              dataLayerHelper({
                event: "fromTheFounderButtonClick",
                label: founderData.bioBtnText,
              })
            }
          >
            {founderData.bioBtnText}
          </ButtonLink>
        </FTFLeftColumn>
        <FTFRightColumn>
          <FounderMessageTitle>
            <span>👋</span> {founderData.title}
          </FounderMessageTitle>
          <FounderMessage
            dangerouslySetInnerHTML={{
              __html: founderData.message.childMarkdownRemark.html,
            }}
          />
        </FTFRightColumn>
        <FounderStraplineContainer>
          <RevolvingText title={title} textArr={straplines} />
          <ButtonLink
            large
            internal
            url={button_url}
            onClick={() =>
              dataLayerHelper({
                event: "revolvingStraplineButtonClicks",
                label: `Bottom-Primary`,
              })
            }
          >
            {button_text}
          </ButtonLink>
        </FounderStraplineContainer>
      </FromTheFounderGrid>
    </FromTheFounderContainer>
  )
}

export default FromTheFounder
